import * as yup from 'yup';

const AlternateTimesValidation = () =>
  yup
    .array()
    .of(
      yup.object({
        requestDate: yup
          .mixed()
          .nullable()
          .required('Requested Date is required'),

        slots: yup
          .array()
          .of(yup.string())
          .min(1, 'Select at least one slot')
          .required('Select at least one slot'),
      }),
    )
    .min(1, 'At least one date and time slot is required')
    .required('At least one date and time slot is required');

export default AlternateTimesValidation;
